import styles from './styles.module.css'

export default function ResultsSaTool({dict}) {
    const {results_sa_tool_1, results_sa_tool_2, results_sa_tool_3} = dict.discover;
    return (
        <section className={styles.results_sa_tool}>
            <p>{results_sa_tool_1}</p>
            <p>{results_sa_tool_2}</p>
            <p>{results_sa_tool_3}</p>
        </section>
    );
}
